<template>
  <div>
    <b-navbar-nav class="mr-auto">
      <b-nav-item-dropdown
        v-if="!readOnlyThales()"
        id="dropdown-catalogue"
        text="Afficher les documents"
        toggle-class="nav-link-custom"
        right>
        <b-dropdown-group id="dropdown-group-1" header="Flux"></b-dropdown-group>
          <b-dropdown-item use-router to="/reference_document/France">France</b-dropdown-item>
          <b-dropdown-item use-router to="/reference_document/Union Europeenne">Union Européenne</b-dropdown-item>
          <b-dropdown-item use-router to="/reference_document/Grand Export">Grand Export</b-dropdown-item>
        </b-dropdown-group>
      </b-nav-item-dropdown>
      <b-nav-item
        use-router
        to="/tracking_order"
      >
        Trouver un document
      </b-nav-item>
      <b-nav-item
        v-if="!readOnlyThales()"
        use-router
        to="/create_order"
      >
        Créer un document
      </b-nav-item>
      <b-nav-item
        v-if="!readOnlyThales()"
        use-router
        to="/scans_stats_board"
      >
        Tableau de pilotage
      </b-nav-item>
    </b-navbar-nav>
    <toggle-navbar />
  </div>
</template>
<script>

import ToggleNavBar from '../components/ToggleNavBar.vue'

export default {
  name: 'ThalesNavBar',
  components: {
    'toggle-navbar': ToggleNavBar
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/app/ThalesNavBar.vue